import {
  Button,
  ButtonProps,
  LabelMedium,
  MatsCircle,
} from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import { selectIsConnected, useDappSelector } from "#/redux-state"
import { routes } from "#/shared/constants"
import { networkUtils } from "#/shared/utils"

export default function HomepageMainSectionBorrowButton(props: ButtonProps) {
  const isConnected = useDappSelector(selectIsConnected)
  return (
    <Button
      data-attr={
        isConnected ? "modal-start_borrow_cta" : "modal-start_borrow-guest_cta"
      }
      $as={Link}
      href={routes.BORROW}
      size="medium"
      startEnhancer={<MatsCircle size={16} />}
      {...props}
    >
      <LabelMedium color="white">
        Borrow MUSD on {networkUtils.getMezoDAppLabel()}
      </LabelMedium>
    </Button>
  )
}
